import ErrorOutline from "@mui/icons-material/ErrorOutline";
import WarningAmber from "@mui/icons-material/WarningAmber";
import { ReactNode } from "react";
import { WarningBoxWrapper } from "components/Common/WarningBox/WarningBox.styles.ts";

interface WarningBoxProps {
	warning: string;
	message: ReactNode | ReactNode[];
	isInfo?: boolean;
}

const WarningBox = ({ warning, message, isInfo }: WarningBoxProps) => {
	const iconProps = {
		"data-testid": isInfo ? "info-icon" : "warning-icon",
		"aria-label": "Warning"
	};

	return (
		<WarningBoxWrapper
			data-testid="warning-box-container"
			isInfo={isInfo}
		>
			{isInfo ? <ErrorOutline {...iconProps} /> : <WarningAmber {...iconProps} />}
			<div>
				<span>{warning}</span>
				<div>{message}</div>
			</div>
		</WarningBoxWrapper>
	);
};

export default WarningBox;
